export default __webpack_public_path__ + "static/media/buttonSoundHover.8a824ede.mp3";